import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/WRI-logo2.webm")